import * as React from 'react';
import styled from 'styled-components';

interface Props {
  s?: React.CSSProperties;
}

const Svg = styled.svg<Props>`
  width: ${({ s }) => s?.width ?? '100%'};
  height: ${({ s }) => s?.height ?? 'auto'};
`;

const WalgreensLogo: React.FunctionComponent<Props> = ({ s }: Props) => (
  <Svg s={s} viewBox="0 0 156.18 163.53">
    <g transform="translate(20, 20)">
      <svg width="116.18" height="123.53" viewBox="0 0 156.18 163.53">
        <defs>
          <path d="M51.457 163.531 0 110.414V13.25l51.457 40.879Zm0 0" id="a" />
        </defs>
        <defs>
          <clipPath id="b">
            <path d="M0 13.133h51.598v74.054H0Zm0 74.054h51.598v64.805H0Zm0 64.805h51.598v11.54H0Zm0 0" />
          </clipPath>
          <clipPath id="c">
            <use xlinkHref="#a" />
          </clipPath>
          <clipPath id="d">
            <use xlinkHref="#a" />
          </clipPath>
          <clipPath id="f">
            <path d="M149 103h7.18v8H149Zm0 0" />
          </clipPath>
          <linearGradient id="e" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#871215" />
            <stop offset="70%" stopColor="#871215" />
            <stop offset="100%" stopColor="#a31e22" />
          </linearGradient>
        </defs>
        <g clipPath="url(#b)">
          <g clipPath="url(#c)">
            <g clipPath="url(#d)">
              <rect
                width="160"
                height="160"
                style={{
                  stroke: 'none',
                  fillRule: 'nonzero',
                  fill: 'url(#e)',
                  fillOpacity: 1,
                }}
              />
            </g>
          </g>
        </g>
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: '#e31837',
            fillOpacity: 1,
          }}
          d="M131.531-.004H.008v110.465H131.53c4.04 0 7.34-3.305 7.34-7.34V7.336c0-4.027-3.3-7.34-7.34-7.34"
        />
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: '#fff',
            fillOpacity: 1,
          }}
          d="M79.133 36.371c2.414-1.184 1.687 2.414 1.687 2.414-.336 4.074-3.3 8.922-5.402 12.653-2.172 3.812-9.746 12.789-13.05 14.726.144-5.437 5.96-17.297 8.929-21.84 1.531-2.652 5.418-6.765 7.836-7.953Zm-15.43 53.684c22.965 4.242 39.774-18.008 50.55-37.258 4.317-7.723 10.852-27.914 3.517-35.55-6.708-7.38-11.899 2.312-15.872 5.538l3.063 3.637c6.129 7.75.805 22.473-2.832 30.34-5.469 9.683-15.762 24.332-27.805 22.289-2.61-.606-4.777-3.153-5.683-5.813 6.48-6.418 14.156-17.687 18.464-25.183 3.633-6.11 9.887-17.895 4.106-22.75-4.793-3.325-14.41 1.465-19.555 5.797-3.129 2.832-5.25 5.14-7.683 8.425-6.618 8.989-12.934 24.383-12.266 36.246-3.191 2.309-6.82 4.602-11.14 3.278-4.282-.957-5.055-4.602-5.66-7.453-2.727-17.192 14.491-38.883 24.156-51.344 0 0-7.626 2.062-13.188 2.3-12.785.551-22.281-5.402-29.2 3.145-2.085 3.035-3.28 6.238-3.675 10.028 2.836-2.414 7.04-1.836 11.05-1.602 6.934.617 10.356 1.441 16.614-.234-5.574 7.847-14.852 23.355-16.57 33.027-.903 6.426-.824 16.539 4.664 21.082 9.094 6.043 18.113 1.824 26.195-3.754 2.39 2.777 5.34 5.203 8.75 5.809"
        />
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: '#939598',
            fillOpacity: 1,
          }}
          d="M145.79 104.465h-2.048v-.738h4.988v.738h-2.062v5.996h-.879v-5.996"
        />
        <g clipPath="url(#f)">
          <path
            style={{
              stroke: 'none',
              fillRule: 'nonzero',
              fill: '#939598',
              fillOpacity: 1,
            }}
            d="M155.156 107.504c-.05-.942-.11-2.078-.11-2.91h-.019a52.5 52.5 0 0 1-.847 2.558l-1.192 3.27h-.66l-1.098-3.207c-.32-.961-.582-1.82-.77-2.621h-.022c-.016.84-.067 1.96-.13 2.98l-.18 2.887h-.827l.469-6.734h1.109l1.148 3.257c.282.829.5 1.567.684 2.266h.02c.175-.68.417-1.418.718-2.266l1.2-3.257h1.109l.418 6.734h-.86l-.16-2.957"
          />
        </g>
      </svg>
    </g>
  </Svg>
);

export default WalgreensLogo;
